@if (myBetsUtilService.isBetCardRedesigned()) {
    <ng-content select="[mybets-expand-betslip-headsection]"></ng-content>
    <div [ngClass]="{ collapsed: collapsed, expanded: !collapsed }" (click)="toggleClick($event)">
        <ng-container [ngTemplateOutlet]="indicator"></ng-container>
    </div>
} @else {
    <div class="mybets-betslip-multi-header clearfix" [ngClass]="{ collapsed: collapsed, expanded: !collapsed }" (click)="toggleClick($event)">
        @if (isEpcotEnabled) {
            <ng-container [ngTemplateOutlet]="indicator"></ng-container>
            <div class="mybets-badge-indicator-divider"></div>
        }
        <ng-content select="[badges]"></ng-content>

        <div class="mybets-betslip-multi-header_title-with-indicator">
            @if (!isEpcotEnabled) {
                <ng-container [ngTemplateOutlet]="indicator"></ng-container>
            }
            <div><ng-content select="[title]"></ng-content></div>
        </div>
    </div>
}

@if (collapsed && !myBetsListContext.isPrintView) {
    <div
        class="mybets-betslip-multi-collapsed-view"
        [ngClass]="{ 'multi-betbuilder-collapsed-view': collapsed && isBetbuilderCombo && !isEpcotEnabled }"
        (click)="toggleClick($event)">
        @if (!isEpcotEnabled || !myBetsUtilService.isBetCardRedesigned()) {
            <ng-content select="[collapsed_view]"></ng-content>
        }
    </div>
} @else {
    @if (!isEpcotEnabled) {
        <div class="mybets-card-divider"></div>
    }
    <ng-content select="[expanded_view]"></ng-content>
}

<ng-template #indicator>
    @if (!myBetsListContext.isPrintView) {
        <div class="mybets-betslip-multi-header_state-indicator-container">
            @if (myBetsUtilService.isBetCardRedesigned()) {
                <span class="mybets-betslip-multi-header_state-indicator font-small"
                    >{{ legsLabel() }}
                    <vn-icon class="redesigned-icon" size="12" [name]="!collapsed ? 'theme-up' : 'theme-down'" />
                </span>
            } @else if (isEpcotEnabled) {
                <vn-icon class="mybets-betslip-multi-header_state-indicator font-small" size="14" [name]="collapsed ? 'theme-down' : 'theme-up'" />
            } @else {
                <vn-icon class="mybets-betslip-multi-header_state-indicator font-small" size="12" [name]="collapsed ? 'theme-right' : 'theme-down'" />
            }
        </div>
    }
</ng-template>
